export enum StudyMimeType {
  SCOPE_VIDEO = 1,
  XRAY_REPORT = 2,
  XRAY = 3,
  OTHER = 4,
}
